const getActiveStoreOffers = (availableProductCategories = [], storeProductCategories)=>{
    const enabledPerStore = storeProductCategories === null || storeProductCategories === void 0 ? void 0 : storeProductCategories.map(({ code  })=>code
    );
    return availableProductCategories.filter(({ key  })=>{
        return enabledPerStore === null || enabledPerStore === void 0 ? void 0 : enabledPerStore.includes(key);
    }).map(({ title , description , image , link  })=>{
        return {
            title,
            description,
            url: link,
            imageUrl: image === null || image === void 0 ? void 0 : image.url
        };
    });
};

export { getActiveStoreOffers };
//# sourceMappingURL=get-active-store-offers.js.map
